import './navigation.scss'
import React, { useEffect, useState } from 'react'
import { getLinkPathname } from './helper'
import { Link } from '../global'

export const SecondaryLinks = ({ menu, setIsSubMenuActive }) => {
  const [links, setLinks] = useState(false)
  const pathname = typeof window !== 'undefined' && window.location.pathname

  useEffect(() => {
    menu.forEach(link => {
      const childItems = link.childItems.nodes
      if (
        childItems.length &&
        (pathname.includes(getLinkPathname(link)) ||
          childItems.find(item => getLinkPathname(item) === pathname))
      ) {
        setLinks(link.childItems.nodes)
        setIsSubMenuActive(true)
      }
    })
  }, [setIsSubMenuActive, menu, pathname])

  return (
    links && (
      <div className="nav-secondary" >
        <div className="innerContainer">
          {links.map(link => (
      <div
      key={link.id}
      className="nav-item"
    >
              <Link
                to={link.path}
                className={`nav-link${
                  (getLinkPathname(link) === pathname && '__active') || ''
                }`}
              >
                {link.label}
              </Link>
            
{/* Drpodown Menu from Menu Item /betonggalan/
{link.path === "/betonggalan/" && (
  <div className="dropdown-menu">
    <DropdownMenu menuItems={links} />
  </div>
)}
*/}
            </div>
          ))}
        </div>
      </div>
    )
  )
}